export default __webpack_public_path__ + "static/media/pic1.5f006b75.png";